import { render, staticRenderFns } from "./RecentlyViewed.vue?vue&type=template&id=4044e9bf&scoped=true"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js"
import style0 from "./RecentlyViewed.vue?vue&type=style&index=0&id=4044e9bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4044e9bf",
  null
  
)

export default component.exports